import React from 'react'
import Product from './Product'
import './Home.css'
import Picture from './pic.jpg';




function Home() {
    return (
        <div className="home">
            <img className="home__image" src={Picture} alt=""/>
            <div className="home__row">
                <Product
                    id="1"
                    title="Gaming Pc"
                    price={16000}
                    rating={4}
                    image="https://m.media-amazon.com/images/I/81YUHsnzj1L._AC_AA180_.jpg">
        
                </Product>
                <Product
                    id="2"
                    title="Acer Nitro 5 Gaming Laptop"
                    price={13981}
                    rating={4}
                    image="https://m.media-amazon.com/images/I/71s1LRpaprL._AC_UY327_FMwebp_QL65_.jpg">
        
                </Product>
                <Product
                    id="9"
                    title="RGB gaming Keyboard"
                    price={694}
                    rating={3}
                    image="https://m.media-amazon.com/images/I/71kr3WAj1FL._AC_UY327_FMwebp_QL65_.jpg">
        
                </Product>

            </div>
            <div className="home__row">
                <Product
                    id="3"
                    title="Sceptre 30-inch Curved Gaming Monitor"
                    price={4589}
                    rating={4}
                    image="https://m.media-amazon.com/images/I/81Wt3h7-V2L._AC_UY327_FMwebp_QL65_.jpg">
        
                </Product>

                <Product
                    id="4"
                    title="TEAMGROUP T-Force Delta RGB 32GB RAM"
                    price={2138}
                    rating={4}
                    image="https://m.media-amazon.com/images/I/61QQMg72PAL._AC_UY327_QL65_.jpg">
        
                </Product>

                <Product
                    id="5"
                    title="Gaming Headset for PS4, PC, Xbox One "
                    price={639}
                    rating={3}
                    image="https://m.media-amazon.com/images/I/61NZPCYSeVL._AC_UY327_QL65_.jpg">
        
                </Product>
                
            </div>
            <div className="home__row">
                <Product
                    id="6"
                    title="
                    Desktop Processor."
                    price={12500}
                    rating={5}
                    image="https://images-na.ssl-images-amazon.com/images/I/51wpN1SESrL._AC_US240_FMwebp_QL65_.jpg">
        
                </Product>
                <Product
                    id="7"
                    title="The Last Of Us II"
                    price={982}
                    rating={5}
                    image="https://images-na.ssl-images-amazon.com/images/I/51QuOXSYxlL._AC_US327_FMwebp_QL65_.jpg">
        
                </Product>
                <Product
                    id="8"
                    title="PlayStation 4 Slim 1TB Console"
                    price={4500}
                    rating={5}
                    image="https://m.media-amazon.com/images/I/71PGvPXpk5L._AC_UY327_FMwebp_QL65_.jpg">
                </Product>
            </div>
            <div className="home__row">
                <Product
                    id="8"
                    title="Cool face mask"
                    price={550}
                    rating={5}
                    image="https://m.media-amazon.com/images/I/51c1WAhXw+L._AC_UL480_FMwebp_QL65_.jpg">
                </Product>
                <Product
                    id="10"
                    title="Airsoft Handgun"
                    price={540}
                    rating={5}
                    image="https://m.media-amazon.com/images/I/61qmMswuWsL._AC_UL480_FMwebp_QL65_.jpg">
                </Product>
                <Product
                    id="11"
                    title="6mm airsoft pistol"
                    price={2195}
                    rating={5}
                    image="https://media.takealot.com/covers_tsins/61499102/61499102-1-flist.jpeg">
                </Product>
                
            </div>
        </div>

    )
}

export default Home
